import request from '@/utils/request'

export function getMedias() {
    return request.get(`/open/constant/medias`)
}

export function getMaterialTypes() {
    return request.get(`/open/constant/material_types`)
}

export function getPlatformTypes(data) {
    return request.get(`/open/constant/platform_types`, data)
}

export function getAdTaskStatus(data) {
    return request.get(`/open/constant/ad_task_status`, data)
}

export function getAdxTaskStatus(data) {
    return request.get(`/open/constant/adx_task_status`, data)
}

export function getLocalMaterialStatus(data) {
    return request.get(`/open/constant/local_material_task_status`, data)
}

export function getPlatformAppTypes(data) {
    return request.get(`/open/constant/platform_app_types`, data)
}

export function getMediaTypes() {
    return request.get(`/open/constant/media_types`)
}

export function getPlayletTypes() {
    return request.get(`/open/constant/playlet_types`)
}

export function getLabels() {
    return request.get(`/open/constant/advertiser_label`)
}
